import React from "react";
import WaveformPlayer from "./waveformPlayer";
import CircularProgressRing from "./CircularProgressRing";

const VoiceInterviewStage = ({
  candidate,
  voiceSession,
  currentStage,
  currentStatus,
  tabLoading,
  isSharedReport,
  handleVoiceCall,
  handleVoiceRefresh,
  formatDateTime,
  loadingCall,
  refreshing,
  audioLoading,
  setAudioLoading,
  expandSummary,
  setExpandSummary,
  expandRecommendation,
  setExpandRecommendation,
  handleScoreClick,
  setShowVideoModal,
  setModalType,
  setShowPhoneCheckModal,
  initiatingVideoCall,
  onScheduleVoice,
}) => {
  const isMobile = window.innerWidth < 767;

  if (tabLoading) {
    return (
      <div className="loading-overlay">
        <div className="spinner-border" />
      </div>
    );
  }
  return (
    <div>
      <div
        className="candidate-assessment-details"
        style={{ flexDirection: "column" }}
      >
        {tabLoading ? (
          <div
            className="loading-overlay"
            style={{
              position: "relative",
              marginTop: 16,
              alignItems: "start",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {(voiceSession?.status === "Ended" && voiceSession?.result) ||
              (voiceSession?.status === "Completed" && voiceSession?.result) ? (
              <>
                <div
                  className="candidate-score d-flex flex-row"
                  style={{
                    gap: "46px",
                    padding: isMobile ? "" : "0 32px",
                    overflowX: "auto",
                    scrollbarWidth: "thin",
                  }}
                >
                  {!isMobile && (
                    <div
                      className="candidate-score-container"
                      style={{ width: "180px", height: "180px" }}
                    >
                      <CircularProgressRing
                        percentage={voiceSession?.result?.overall_score || 0}
                        label="Voice interview"
                      />
                    </div>
                  )}
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ gap: "24px" }}
                  >
                    {voiceSession?.result?.analysis?.structured_analysis && (
                      <div className="d-flex" style={{ gap: "24px" }}>
                        <div className="voice-score">
                          <h6>
                            {
                              voiceSession?.result?.analysis
                                ?.structured_analysis
                                ?.communication_weighted_score
                            }
                            /
                            {voiceSession?.result?.analysis?.structured_analysis
                              ?.weights_used?.communication || "25"}
                          </h6>
                          <p>Communication Weighted Score</p>
                        </div>
                        <div className="voice-score">
                          <h6>
                            {
                              voiceSession?.result?.analysis
                                ?.structured_analysis?.technical_weighted_score
                            }
                            /
                            {voiceSession?.result?.analysis?.structured_analysis
                              ?.weights_used?.technical || "60"}
                          </h6>
                          <p>Technical Weighted Score</p>
                          <button onClick={() => handleScoreClick("technical")}>
                            View
                          </button>
                        </div>
                        <div className="voice-score">
                          <h6>
                            {
                              voiceSession?.result?.analysis
                                ?.structured_analysis
                                ?.cultural_fit_weighted_score
                            }
                            /
                            {voiceSession?.result?.analysis?.structured_analysis
                              ?.weights_used?.cultural_fit || "15"}
                          </h6>
                          <p>Cultural Fit Weighted Score</p>
                          <button onClick={() => handleScoreClick("cultural")}>
                            View
                          </button>
                        </div>
                        <div className="voice-score">
                          <h6>
                            {
                              voiceSession?.result?.analysis
                                ?.structured_analysis?.final_weighted_score
                            }
                            /100
                          </h6>
                          <p>Final Weighted Score</p>
                          <button onClick={() => handleScoreClick("final")}>
                            View
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="voice-score">
                      {voiceSession?.completed_at ? (
                        <div>
                          <h6 style={{ height: "unset", fontSize: "20px" }}>
                            {new Date(voiceSession.completed_at)
                              .toLocaleString(undefined, {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              })
                              .replace(",", "")}
                          </h6>
                          <p style={{ height: "unset" }}>Completed</p>
                        </div>
                      ) : (
                        <div>
                          <h6 style={{ height: "unset", fontSize: "20px" }}>
                            {new Date(voiceSession.updated_at)
                              .toLocaleString(undefined, {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                              })
                              .replace(",", "")}
                          </h6>
                          <p style={{ height: "unset" }}>Completed</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="candidate-assessment-items"
                  style={{ width: "100%", borderRadius: "none" }}
                >
                  {isMobile ? (
                    <div class="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="false"
                            aria-controls="collapseOne"
                          >
                            Summary
                          </button>
                        </h2>
                        <div
                          id="collapseOne"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body" style={{ padding: '0 20px' }}>
                            {voiceSession?.result?.summary}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Recommendation
                          </button>
                        </h2>
                        <div
                          id="collapseTwo"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body" style={{ padding: '0 20px' }}>
                            {voiceSession.result.recommendation}
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            Audio and Transcript
                          </button>
                        </h2>
                        <div
                          id="collapseThree"
                          class="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div class="accordion-body" style={{ padding: '0' }}>
                            <div
                              className="candidate-assessment-items"
                              style={{ width: "100%" }}
                            >
                              <div className="candidate-assessment-audio">
                                <h5>Interview audio</h5>
                                {audioLoading && (
                                  <div
                                    className="loading-overlay"
                                    style={{ height: 60, width: "380px" }}
                                  >
                                    <div className="spinner-border" role="status">
                                      <span className="visually-hidden">
                                        Loading audio...
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: audioLoading ? "none" : "block",
                                  }}
                                >
                                  <WaveformPlayer
                                    audioUrl={
                                      voiceSession?.result?.stereo_audio_url
                                    }
                                    onLoadingChange={setAudioLoading}
                                    hideDownload={isSharedReport}
                                  />
                                </div>
                              </div>
                              <h5>Transcript</h5>
                              <div
                                className="candidate-assessment-transcript"
                                style={{
                                  height: "230px",
                                  overflow: "auto",
                                  scrollbarWidth: "thin",
                                }}
                              >
                                {voiceSession?.result?.messages?.map(
                                  (msg, idx) => {
                                    if (
                                      msg.role === "system" ||
                                      !msg.message?.trim()
                                    )
                                      return null;
                                    const isAgent =
                                      msg.role === "bot" ||
                                      msg.role === "tool_calls" ||
                                      msg.role === "tool_call_result";
                                    const speaker = isAgent
                                      ? "Agent voice"
                                      : candidate?.name;
                                    return (
                                      <div
                                        className="transcript"
                                        key={idx}
                                        style={{ marginBottom: "10px" }}
                                      >
                                        <div className="transcript-text">
                                          {isAgent ? (
                                            <img
                                              src="/images/candidate-example.jpeg"
                                              alt="avatar"
                                            />
                                          ) : (
                                            <div className="user-avatar">
                                              {candidate.name
                                                ?.charAt(0)
                                                .toUpperCase() || "U"}
                                            </div>
                                          )}
                                          &nbsp;<h5>{speaker}</h5>
                                        </div>
                                        <p>{msg.message}</p>
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="assessment-score">
                      <div className="assessment-score-sections">
                        <div
                          className="assessment-score-summary"
                          style={{
                            width: voiceSession?.result?.recommendation
                              ? "50%"
                              : "100%",
                          }}
                        >
                          <div
                            style={{
                              borderRight: "1px solid #e5e7eb",
                              paddingRight: "20px",
                            }}
                          >
                            <h5>Summary</h5>
                            <div className="text-summary-container">
                              <p
                                className={`summary-text ${expandSummary ? "expanded" : "clamped"
                                  }`}
                              >
                                {voiceSession?.result?.summary}
                              </p>
                              {!expandSummary && (
                                <span
                                  className="read-more"
                                  onClick={() => setExpandSummary(true)}
                                >
                                  View more
                                </span>
                              )}
                              {expandSummary && (
                                <span
                                  className="read-more"
                                  onClick={() => setExpandSummary(false)}
                                >
                                  View less
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        {voiceSession?.result?.recommendation && (
                          <div
                            className="assessment-score-summary"
                            style={{ width: "50%" }}
                          >
                            <h5>Recommendation</h5>
                            <div className="text-summary-container">
                              <p
                                className={`summary-text ${expandRecommendation ? "expanded" : "clamped"
                                  }`}
                              >
                                {voiceSession.result.recommendation}
                              </p>
                              {!expandRecommendation && (
                                <span
                                  className="read-more"
                                  onClick={() => setExpandRecommendation(true)}
                                >
                                  View more
                                </span>
                              )}
                              {expandRecommendation && (
                                <span
                                  className="read-more"
                                  onClick={() => setExpandRecommendation(false)}
                                >
                                  View less
                                </span>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                {!currentStage ? (
                  <div
                    className="candidate-assessment-items"
                    style={{ border: "none", width: "100%" }}
                  >
                    {!isSharedReport && (
                      <button
                        className="candidate-assessment-calling"
                        onClick={() => {
                          const hasCountryCode = /^\+\d{1,3}/.test(
                            candidate?.phone_number || "",
                          );
                          if (hasCountryCode) {
                            handleVoiceCall();
                          } else {
                            setShowPhoneCheckModal(true);
                          }
                        }}
                        disabled={loadingCall}
                      >
                        {loadingCall
                          ? "Initiating call..."
                          : "Make a voice call"}
                      </button>
                    )}
                    {!isSharedReport && (
                      <button
                        className="candidate-assessment-calling"
                        onClick={() => {
                          const hasCountryCode = /^\+\d{1,3}/.test(
                            candidate?.phone_number || "",
                          );
                          if (hasCountryCode) {
                            onScheduleVoice();
                          } else {
                            setShowPhoneCheckModal(true);
                          }
                        }}
                        disabled={initiatingVideoCall}
                      >
                        Schedule a voice interview
                      </button>
                    )}
                  </div>
                ) : currentStatus === "ASSIGNED" ? (
                  <div
                    className="candidate-assessment-items"
                    style={{ border: "none", width: "100%" }}
                  >
                    <p className="d-flex align-items-center">
                      Voice Call assigned, yet to be scheduled
                    </p>
                  </div>
                ) : currentStatus === "NOT SCHEDULED" ? (
                  <div
                    className="candidate-assessment-items"
                    style={{ border: "none", width: "100%" }}
                  >
                    <p className="d-flex align-items-center">
                      Voice Call assigned, yet to be scheduled
                    </p>
                  </div>
                ) : currentStatus === "SCHEDULED" ? (
                  <div
                    className="candidate-assessment-items"
                    style={{ border: "none", width: "100%" }}
                  >
                    <p>
                      Voice Call scheduled at{" "}
                      {formatDateTime(currentStage.scheduled_at)}
                    </p>
                  </div>
                ) : currentStatus === "ONGOING" ? (
                  <div
                    className="candidate-assessment-items"
                    style={{
                      border: "none",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p>Voice Call is in progress</p>
                    <button
                      className="refresh-btn"
                      onClick={handleVoiceRefresh}
                      disabled={refreshing}
                    >
                      <img
                        src="/images/reset.svg"
                        alt=""
                        width={16}
                        height={16}
                      />
                    </button>
                  </div>
                ) : currentStatus === "EXPIRED" ? (
                  <div
                    className="candidate-assessment-items"
                    style={{ border: "none", width: "100%" }}
                  >
                    <div>
                      <div className="d-flex">
                        {!isSharedReport && (
                          <button
                            className="candidate-assessment-calling"
                            onClick={() => {
                              const hasCountryCode = /^\+\d{1,3}/.test(
                                candidate?.phone_number || "",
                              );
                              if (hasCountryCode) {
                                handleVoiceCall();
                              } else {
                                setShowPhoneCheckModal(true);
                              }
                            }}
                            disabled={loadingCall}
                          >
                            {loadingCall
                              ? "Initiating call..."
                              : "Make a voice call again"}
                          </button>
                        )}
                        &nbsp;&nbsp;
                        {!isSharedReport && (
                          <button
                            className="candidate-assessment-calling"
                            onClick={() => {
                              const hasCountryCode = /^\+\d{1,3}/.test(
                                candidate?.phone_number || "",
                              );
                              if (hasCountryCode) {
                                onScheduleVoice();
                              } else {
                                setShowPhoneCheckModal(true);
                              }
                            }}
                            disabled={initiatingVideoCall}
                          >
                            Schedule a voice interview
                          </button>
                        )}
                      </div>
                      <p
                        className="d-flex align-items-center"
                        style={{ color: "#FF5733" }}
                      >
                        Voice call stage has been expired
                      </p>
                    </div>
                  </div>
                ) : ["FAILED", "NOT COMPLETED", "REVOKED"].includes(
                  currentStatus,
                ) ? (
                  <div
                    className="candidate-assessment-items"
                    style={{ border: "none", width: "100%" }}
                  >
                    <div>
                      <div className="d-flex">
                        {!isSharedReport && (
                          <button
                            className="candidate-assessment-calling"
                            onClick={() => {
                              const hasCountryCode = /^\+\d{1,3}/.test(
                                candidate?.phone_number || "",
                              );
                              if (hasCountryCode) {
                                handleVoiceCall();
                              } else {
                                setShowPhoneCheckModal(true);
                              }
                            }}
                            disabled={loadingCall}
                          >
                            {loadingCall
                              ? "Initiating call..."
                              : "Make a voice call again"}
                          </button>
                        )}
                        &nbsp;&nbsp;
                        {!isSharedReport && (
                          <button
                            className="candidate-assessment-calling"
                            onClick={() => {
                              const hasCountryCode = /^\+\d{1,3}/.test(
                                candidate?.phone_number || "",
                              );
                              if (hasCountryCode) {
                                onScheduleVoice();
                              } else {
                                setShowPhoneCheckModal(true);
                              }
                            }}
                            disabled={initiatingVideoCall}
                          >
                            Schedule a voice interview
                          </button>
                        )}
                      </div>
                      <p
                        className="d-flex align-items-center"
                        style={{ color: "#FF5733", marginTop: "10px" }}
                      >
                        Voice call failed{" "}
                        {voiceSession?.meta_data?.failure_reason && (
                          <>Reason: {voiceSession.meta_data.failure_reason}</>
                        )}
                      </p>
                    </div>
                  </div>
                ) : (currentStatus === "COMPLETED" &&
                  voiceSession?.result === "null") ||
                  (currentStatus === "COMPLETED" &&
                    voiceSession?.result === null) ? (
                  <div
                    className="candidate-assessment-items"
                    style={{
                      border: "none",
                      width: "100%",
                      borderRadius: "none",
                    }}
                  >
                    <p>
                      Voice Call is Completed waiting for result to get updated
                    </p>
                  </div>
                ) : (currentStatus === "COMPLETED" ||
                  voiceSession?.status === "Ended") &&
                  voiceSession?.result ? (
                  <>
                    <div
                      className="candidate-assessment-items"
                      style={{ width: "100%", borderRadius: "none" }}
                    >
                      <div className="candidate-score">
                        <div className="candidate-score-container">
                          <CircularProgressRing
                            percentage={
                              voiceSession?.result?.overall_score || 0
                            }
                            label="Voice interview"
                          />
                        </div>
                      </div>
                      <div className="assessment-score">
                        <h5>Overall score</h5>
                        <p
                          style={{
                            height: "135px",
                            width: "70%",
                            overflow: "auto",
                            scrollbarWidth: "none",
                          }}
                        >
                          {
                            voiceSession?.result?.analysis?.structured_analysis
                              ?.summary
                          }
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <p>Unknown or pending state</p>
                )}
              </>
            )}
          </>
        )}
      </div>
      <div className="candidate-assessment-details">
        {tabLoading ? (
          <div
            className="loading-overlay"
            style={{
              position: "relative",
              marginTop: 16,
              alignItems: "start",
            }}
          >
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {(currentStatus === "COMPLETED" && voiceSession?.result) ||
              (voiceSession?.status === "Ended" && voiceSession?.result) ||
              (voiceSession?.status === "Completed" && voiceSession?.result) ? (
              <>
                {!isMobile && (
                  <div
                    className="candidate-assessment-items"
                    style={{ width: "100%" }}
                  >
                    <div className="candidate-assessment-audio">
                      <h5>Interview audio</h5>
                      {audioLoading && (
                        <div
                          className="loading-overlay"
                          style={{ height: 60, width: "380px" }}
                        >
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">
                              Loading audio...
                            </span>
                          </div>
                        </div>
                      )}
                      <div style={{ display: audioLoading ? "none" : "block" }}>
                        <WaveformPlayer
                          audioUrl={voiceSession?.result?.stereo_audio_url}
                          onLoadingChange={setAudioLoading}
                          hideDownload={isSharedReport}
                        />
                      </div>
                    </div>
                    <div
                      className="candidate-assessment-transcript"
                      style={{
                        height: "230px",
                        overflow: "auto",
                        scrollbarWidth: "thin",
                      }}
                    >
                      <h4>Transcript</h4>
                      {voiceSession?.result?.messages?.map((msg, idx) => {
                        if (msg.role === "system" || !msg.message?.trim())
                          return null;
                        const isAgent =
                          msg.role === "bot" ||
                          msg.role === "tool_calls" ||
                          msg.role === "tool_call_result";
                        const speaker = isAgent
                          ? "Agent voice"
                          : candidate?.name;
                        return (
                          <div
                            className="transcript"
                            key={idx}
                            style={{ marginBottom: "10px" }}
                          >
                            <div className="transcript-text">
                              {isAgent ? (
                                <img
                                  src="/images/candidate-example.jpeg"
                                  alt="avatar"
                                />
                              ) : (
                                <div className="user-avatar">
                                  {candidate.name?.charAt(0).toUpperCase() ||
                                    "U"}
                                </div>
                              )}
                              &nbsp;<h5>{speaker}</h5>
                            </div>
                            <p>{msg.message}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

export default VoiceInterviewStage;
